module.exports = __webpack_public_path__ + "img/tn-timeline-main-5.9557b417.jpg";